<template>
    <v-container class=" pa-0" fill-height fluid>
        <v-row class="fill-height bkgOverlay">
            <v-col cols="12" md="4" class="d-flex flex-column justify-space-around align-center justify-center">
                <div>
                <v-img @click="$router.push(`/`)" contain width="140px" height="80px" src="../assets/logo.png" style="cursor:pointer" />
            </div>
                <v-form v-if="!esqueciSenha" style="width:100%" class="mx-5 mx-md-10 pa-3 efeito-vidro">
                    
                    <h1 class="inter" style="color:#F15A24">Login</h1>
                    <v-text-field color="#F15A24"  label="E-mail" type="text" prepend-inner-icon="mdi-email" name="strLogin" v-model="u.strLogin"> </v-text-field>
                    <v-text-field color="#F15A24" @click:append="show1 = !show1" prepend-inner-icon="mdi-key"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"  label="Senha"
                        :type="show1 ? 'text' : 'password'" name="strPassword" v-model="u.strPassword"> </v-text-field>
                    <div class="text-left mt-5">
                        <v-btn block color="#F15A24" class="inter" :loading="loading" dark @click="login($event)">
                            Entrar
                            <v-icon dark>mdi-arrow-right</v-icon>
                        </v-btn>
                        <v-btn block text  @click="esqueciSenha = true" class="inter mt-5 btn btn-tertiary">
                            Esqueci a senha
                        </v-btn>
                    </div>
                </v-form>   
                <v-form v-if="esqueciSenha" @submit="esqueceuSenha" style="width:100%"  class="mx-5 mx-md-10 pa-3 pt-5 efeito-vidro">
                    <h3 class="inter" style="color:#F15A24">Esqueci a Senha</h3>

                    <v-text-field color="#F15A24" class="mt-5" dense style="" filled label="E-mail" type="text" prepend-inner-icon="mdi-email" name="strLogin" v-model="u.strLogin"> </v-text-field>
                    <div class="text-left">
                        <v-btn :loading="loadingEsqueciSenha" @click="esqueceuSenha" block dark color="#F15A24" class="btn btn-primary mb-5">
                            Enviar
                            <v-icon dark>mdi-arrow-right</v-icon>
                        </v-btn>
                        <v-btn text @click="esqueciSenha = false" class="btn btn-tertiary">
                            Voltar
                        </v-btn>
                    </div>
                </v-form>
            </v-col>
            <v-col cols="12" md="8" class=" bkgLogin d-flex align-center justify-center">
                <img width="60%" src="../assets/who/grupoAllColor.png" alt="Grupo de usuarios do mylegis">

            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">
            {{ snackText }}

            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    Ok
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>
<style scoped>

.efeito-vidro {
    background: rgba(255, 255, 255, 1) !important;
    backdrop-filter: blur(1.5px) !important;
    -webkit-backdrop-filter: blur(13.5px) !important;
    border-radius: 10px !important;
    /* border: 1px solid #F15A2455 !important; */
    /* filter: drop-shadow(0px 0px 5px #F15A2455); */
}

form {
    /* background-color: #4D4D4F; */
    max-width: 90%;
    margin: auto;
}

.bkgLogin {
    
    background-size: cover;
    background-position: center;
    background-color:#F15A24;
}

.bkgOverlay {
    background-color: rgba(255,255,255, 0);
}
</style>
<script>

export default {
    name: 'Login',
    data() {
        return {
            snackbar: false,
            show1: false,
            loading: false,
            u: {
                strLogin: "",
                strPassword: ""
            },
            esqueciSenha: false,
            loadingEsqueciSenha: false,
            snackText: ""
        }
    },
    computed: {
        intBreakPoint() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return 0;
                case "sm":
                    return 1;
                case "md":
                    return 2;
                case "lg":
                    return 3;
                case "xl":
                    return 4;
                default:
                    return 0;
            }
        }
    },
    methods: {
        async login(e) {
            e.preventDefault()
            this.loading = true
            let email = this.u.strLogin
            let password = this.u.strPassword
            try {
                await this.$store.dispatch('login', { email, password })
            } catch (err) {
                // window.console.log(err)
                this.loading = false
                this.snackText = "Login inválido. Confira suas credenciais."
                this.snackbar = true
                return;
            }
            this.loading = false

            await this.$store.dispatch("getInfo")
            await this.$router.push('/painel/legislacoes')
        },
        esqueceuSenha(e) {
            e.preventDefault()
            this.loadingEsqueciSenha = true
            let strEmail = this.u.strLogin
            if (strEmail == "") {
                this.snackText = "Por favor utilize um email válido."
                this.snackbar = true
                this.loadingEsqueciSenha = false

                return
            }

            this.$http.post("auth/password/request", {
                email: strEmail,
                reset_url: "https://mylegis.com.br/nova-senha/"
            }).then(response => {
                if (response.data != undefined) {
                    this.snackText = "Um email foi enviado com as informações necessarias."
                    this.snackbar = true
                    this.u.strLogin = ""
                    this.esqueciSenha = false
                } 
                this.loadingEsqueciSenha = false
            }).catch(() => {
                this.loadingEsqueciSenha = false

             })

        }
    }
}
</script>

